// v1.47 — hand a dropped supplier-invoice File from the Bill document view to
// the Bill reconcile view, which owns the parse/import engine. The document
// view stashes the File here and navigates to ?mode=reconcile; the reconcile
// view consumes it once on mount and runs its normal import flow.

let pendingBillImportFile: File | null = null;

export function setPendingBillImportFile(file: File | null): void {
  pendingBillImportFile = file;
}

/** Returns the pending file (if any) and clears it so it's consumed once. */
export function consumePendingBillImportFile(): File | null {
  const f = pendingBillImportFile;
  pendingBillImportFile = null;
  return f;
}
